import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

interface SmallModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  content?: React.ReactNode; // Permitir cualquier contenido React
}

export const SmallModal: React.FC<SmallModalProps> = ({ open, onClose, title = "Modal Title", content }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {content}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};